var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificationFilledWhite16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C6BDB8CE-8283-4C51-98B1-700BFB65DAF2_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-1226.000000, -32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1218.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-/-None"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,23 C18,24.1045695 17.1045695,25 16,25 C14.8954305,25 14,24.1045695 14,23 L9,23 C8.447,23 8,22.553 8,22 C8,21.404 8.438,21.156 8.437,21.156 C9.303,20.656 10,19.209 10,17 L10,14 C10,10.322 12.979,8 16,8 C18.959,8 22,10.385 22,14 L22,17.026 C22,19.011 22.34,20.444 23.363,21.073 C23.296,21.047 24,21.276 24,22 C24,22.553 23.553,23 23,23 L18,23 Z",
    id: "Icon_Notification-Filled_White-16px"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationFilledWhite16Px);
export default __webpack_public_path__ + "static/media/Icon_Notification-Filled_White-16px.d45a3cf721f24d2ec2efdc59f5c8eaaf.svg";
export { ForwardRef as ReactComponent };